import defaultConfig from "@/config";

export const ImageSizes = {
  THUMBNAIL: "thumbnail",
  MEDIUM: "medium",
  FULL_VIEW: "fullView"
};

export function getSizedImageUrl(imageName, size = "thumbnail", oldPath = "product-images", config = defaultConfig) {
  if (!imageName) return;

  if (typeof imageName === "object") {
    imageName = imageName.src || imageName.file_url || imageName.url;
  }

  if (!imageName) return;

  if (!config.imagekit) {
    config = { ...config, imagekit: defaultConfig.imagekit };
  }

  const imageBaseUrl = config.imageBaseUrl || config.api.replace("/api", "");
  let resultUrl = imageName.indexOf("http") > -1
    ? imageName
    : `${imageBaseUrl}/uploads/${oldPath}/${imageName}`;

  if (imageName.indexOf("im__") > -1 || imageName.indexOf("imagekit__") > -1) {
    switch (size) {
      case ImageSizes.THUMBNAIL:
        resultUrl = config.imagekit.thumbnail + imageName;
        break;
      case ImageSizes.MEDIUM:
        resultUrl = config.imagekit.medium + imageName;
        break;
      case ImageSizes.FULL_VIEW:
        resultUrl = config.imagekit.full + imageName;
        break;
    }
  }

  return resultUrl;
}
